import {makeAuthorizeHttpClientDecorator} from "../decorators/authorize-http-client-decorator-factory";
import {ReportsFiltersDatasource} from "../../../data/datasources/reports-filters-datasource";

export const makeReportsFiltersDatasource = () => new ReportsFiltersDatasource(makeAuthorizeHttpClientDecorator())
